// @flow

import keyMirror from 'keymirror';

const Events = keyMirror({
  END_LOADING: null,

  CHANGE: null, // TODO: remove

  ON_LOADING_RESTAURANT_SUCCESS: null,

  TIMER_DONE: null,

  ON_ERROR: null,
  ON_LOGIN_ERROR: null,

  ON_LOGIN_SUCCESS: null,

  ON_LOADING_USER: null, // TODO: Change for _SUCCESS
  ON_LOADING_USER_ERROR: null,

  ON_LOADING_USER_REVIEWS_SUMMARY: null, // TODO: Change for _SUCCESS
  ON_LOADING_USER_REVIEWS_SUMMARY_ERROR: null,

  ON_LOADING_BOOKINGS: null, // TODO: Change for _SUCCESS
  ON_LOADING_BOOKINGS_ERROR: null,

  ON_BOOKINGS_DATE_CHANGE: null,

  ON_CREATE_BOOKING: null, // TODO: Change for _SUCCESS
  ON_CREATE_BOOKING_ERROR: null,

  ON_UPDATE_BOOKING: null, // TODO: Change for _SUCCESS
  ON_UPDATE_BOOKING_ERROR: null,

  ON_LOADING_BOOKING_SLOTS_SUCCESS: null,
  ON_LOADING_BOOKING_SLOTS_ERROR: null,

  ON_LOADING_GUESTS_BOOKED_SUCCESS: null,
  ON_LOADING_GUESTS_BOOKED_ERROR: null,

  ON_LOADING_WAITING_BOOKINGS_SUCCESS: null,
  ON_LOADING_WAITING_BOOKINGS_ERROR: null,

  ON_LOADING_UPDATED_BOOKINGS_SUCCESS: null,
  ON_LOADING_UPDATED_BOOKINGS_ERROR: null,

  ON_LOADING_BOOKING_SETTINGS_SUCCESS: null,
  ON_LOADING_BOOKING_SETTINGS_ERROR: null,

  ON_LOADING_BOOKING_SPECIFICS_SETTINGS_SUCCESS: null,
  ON_LOADING_BOOKING_SPECIFICS_SETTINGS_ERROR: null,

  ON_LOADING_CAPACITY_SPECIFICS_SUCCESS: null,
  ON_LOADING_CAPACITY_SPECIFICS_ERROR: null,

  ON_CREATE_CAPACITY_SPECIFIC_SUCCESS: null,
  ON_CREATE_CAPACITY_SPECIFIC_ERROR: null,

  ON_UPDATE_CAPACITY_SPECIFIC_SUCCESS: null,
  ON_UPDATE_CAPACITY_SPECIFIC_ERROR: null,

  ON_DELETE_CAPACITY_SPECIFIC_SUCCESS: null,
  ON_DELETE_CAPACITY_SPECIFIC_ERROR: null,

  ON_UPDATE_BOOKING_SETTINGS_SUCCESS: null,
  ON_UPDATE_BOOKING_SETTINGS_ERROR: null,

  CREATE_RESTAURANT_SUCCESS: null,
  CREATE_RESTAURANT_FAILURE: null,

  //
  // Menu
  //
  ON_LOADING_RESTAURANT_MENU: null,
  ON_LOADING_RESTAURANT_MENU_SUCCESS: null,
  ON_LOADING_RESTAURANT_MENU_ERROR: null,

  ON_UPDATE_RESTAURANT_MENU_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_ERROR: null,

  //
  // Menu - Product
  //

  ON_UPDATE_RESTAURANT_MENU_PRODUCT_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_PRODUCT_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_PRODUCT_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_PRODUCT_ERROR: null,

  ON_CREATE_RESTAURANT_MENU_PRODUCT_SUCCESS: null,
  ON_CREATE_RESTAURANT_MENU_PRODUCT_ERROR: null,

  //
  // Menu - ProductOption
  //

  ON_UPDATE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR: null,

  ON_CREATE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS: null,
  ON_CREATE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR: null,

  //
  // Menu - Menu
  //

  ON_UPDATE_RESTAURANT_MENU_MENU_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_MENU_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_MENU_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_MENU_ERROR: null,

  ON_CREATE_RESTAURANT_MENU_MENU_SUCCESS: null,
  ON_CREATE_RESTAURANT_MENU_MENU_ERROR: null,

  //
  // Menu - Menu Part
  //

  ON_UPDATE_RESTAURANT_MENU_MENU_PART_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_MENU_PART_ERROR: null,

  //
  // Menu - Menu Part - Category
  //

  ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_ERROR: null,

  //
  // Menu - Category
  //

  ON_UPDATE_RESTAURANT_MENU_CATEGORY_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_CATEGORY_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_CATEGORY_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_CATEGORY_ERROR: null,

  ON_CREATE_RESTAURANT_MENU_CATEGORY_SUCCESS: null,
  ON_CREATE_RESTAURANT_MENU_CATEGORY_ERROR: null,

  //
  // Menu - UpsellingCategory
  //
  ON_UPDATE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR: null,

  ON_CREATE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS: null,
  ON_CREATE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR: null,

  //
  // Dashboard
  //

  ON_LOADING_RESTAURANT_DASHBOARD_INFO_SUCCESS: null,
  ON_LOADING_RESTAURANT_DASHBOARD_INFO_ERROR: null,

  ON_LOADING_BOOKING_NOTIFICATIONS_SETTINGS: null,
  ON_LOADING_BOOKING_NOTIFICATIONS_SETTINGS_ERROR: null,

  ON_PDF_BOOKINGS_LIST_LINK_SUCCESS: null,
  ON_PDF_BOOKINGS_LIST_LINK_FAILURE: null,

  //
  // Pro accounts
  //
  PRO_FORGOT_PASSWORD: null,

  PRO_ACCOUNT_GET_ME_SUCCESS: null,
  PRO_ACCOUNT_GET_ME_FAILURE: null,

  PRO_ACCOUNT_CREATE_SUCCESS: null,
  PRO_ACCOUNT_CREATE_FAILURE: null,

  PRO_ACCOUNT_GET_SUCCESS: null,
  PRO_ACCOUNT_GET_FAILURE: null,

  PRO_ACCOUNT_UPDATE_SUCCESS: null,
  PRO_ACCOUNT_UPDATE_FAILURE: null,

  PRO_ACCOUNT_DELETE_SUCCESS: null,
  PRO_ACCOUNT_DELETE_FAILURE: null,

  PRO_ACCOUNT_GET_DOMAINS_SUCCESS: null,
  PRO_ACCOUNT_GET_DOMAINS_FAILURE: null,

  //
  // Restaurant
  //
  LOAD_RESTAURANT_SUCCESS: null,
  LOAD_RESTAURANT_FAILURE: null,

  UPDATE_RESTAURANT_SUCCESS: null,
  UPDATE_RESTAURANT_FAILURE: null,

  LOAD_RESTAURANTS_GROUP_SUCCESS: null,
  LOAD_RESTAURANTS_GROUP_FAILURE: null,

  CREATE_RESTAURANTS_GROUP_SUCCESS: null,
  CREATE_RESTAURANTS_GROUP_FAILURE: null,

  UPDATE_RESTAURANTS_GROUP_SUCCESS: null,
  UPDATE_RESTAURANTS_GROUP_FAILURE: null,

  LOAD_RESTAURANT_ROLES_SUCCESS: null,
  LOAD_RESTAURANT_ROLES_FAILURE: null,

  // triggered when the user change the selected restaurant / restaurantsGroup
  // we have to re-render the whole page.
  RESTAURANT_CHANGE_REQUEST: null,
  RESTAURANT_CHANGE_SUCCESS: null,
  RESTAURANT_CHANGE_FAILURE: null,

  //
  // Role
  //

  UPDATE_ROLE_SUCCESS: null,
  UPDATE_ROLE_FAILURE: null,

  CREATE_ROLE_SUCCESS: null,
  CREATE_ROLE_FAILURE: null,

  DELETE_ROLE_SUCCESS: null,
  DELETE_ROLE_FAILURE: null,

  //
  // Security
  //

  ON_PRO_ROLE_WITH_ELEVATION_CODE_SUCCESS: null,
  ON_PRO_ROLE_WITH_ELEVATION_CODE_FAILURE: null,

  //
  // Order
  //

  ON_UPDATE_ORDER_SETTINGS_SUCCESS: null,
  ON_UPDATE_ORDER_SETTINGS_FAILURE: null,

  ON_LOAD_ORDER_SETTINGS_SUCCESS: null,
  ON_LOAD_ORDER_SETTINGS_FAILURE: null,

  ON_RETRIEVE_ORDERS_LIST_SUCCESS: null,
  ON_RETRIEVE_ORDERS_LIST_FAILURE: null,

  ON_RETRIEVE_ORDERS_LIST_BY_DUE_DATE_SUCCESS: null,
  ON_RETRIEVE_ORDERS_LIST_BY_DUE_DATE_FAILURE: null,

  UPDATE_ORDER_SUCCESS: null,
  UPDATE_ORDER_FAILURE: null,

  GET_CUSTOM_TEXTS_CONTAINER_SUCCESS: null,
  GET_CUSTOM_TEXTS_CONTAINER_FAILURE: null,
  POST_CUSTOM_TEXTS_CONTAINER_SUCCESS: null,
  POST_CUSTOM_TEXTS_CONTAINER_FAILURE: null,
  PUT_CUSTOM_TEXTS_CONTAINER_SUCCESS: null,
  PUT_CUSTOM_TEXTS_CONTAINER_FAILURE: null,

  //
  // Other
  //

  ON_QUERY_PARAMS_UPDATE: null
});

export default Events;



// WEBPACK FOOTER //
// ./scripts/constants/Events.js